import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../../../util/Rest';
import {APPLY_SEQUENCE_OVERRIDE_TABLE, APPLICATION_SEQUENCE} from '../../../../constants/Lookup';
import {CLIENT_MAINTENANCE} from '../../../../constants/MicroServiceConstants';

const initialValues = {
  applySequenceData: {},
  applySequenceStatus: null,
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'applySequence',
  initialState: {...initialValues},
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchApplySequenceData: (state, action) => {
      state.applySequenceData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postApplySequenceData: (state, action) => {
      state.applySequenceStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetApplySequence: (state) => {
      state.applySequenceStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

const {
  fetchStart,
  fetchDropDownData,
  resetApplySequence,
  fetchApplySequenceData,
  postApplySequenceData,
  resetMsg,
  fetchError,
} = slice.actions;

export const fetchDropDown = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [APPLY_SEQUENCE_OVERRIDE_TABLE, APPLICATION_SEQUENCE],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchApplySequence = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${CLIENT_MAINTENANCE}/find/deptorsequence/${clientNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchApplySequenceData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postApplySequence = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/deptorsequence`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postApplySequenceData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetApplySequence());
  };
};
